import React from "react";
import clsx from "clsx";

import { DEFAULT_COLUMN, SORT_ORDER, ICONS } from "../constants";

const TableHeader = ({
  columns = [],
  sortBy,
  onSort = () => {},
  onSelect,
  allowActions,
  isAllSelected = false,
  noAction = false,
}) => {
  const handleSelectAll = (event) => {
    const { checked } = event.target;
    onSelect(null, null, checked);
  };

  const handleSort = (field, index) => {
    let order = SORT_ORDER.ASC;

    if (sortBy && sortBy.field === field && sortBy.order === SORT_ORDER.ASC) {
      order = SORT_ORDER.DESC;
    }

    if (sortBy && sortBy.field === field && sortBy.order === SORT_ORDER.DESC) {
      return onSort(null);
    }

    onSort({ field, order, index });
  };

  const _renderSortIcon = (column, columnIndex) => {
    return (
      <span
        className={clsx("sort-icon", {
          "sort-active": sortBy && columnIndex === sortBy.index,
          "sort-desc-active": sortBy?.order === SORT_ORDER.DESC,
          "sort-asc-active": sortBy?.order === SORT_ORDER.ASC,
        })}
        onClick={() => handleSort(column.key, columnIndex)}
      >
        <span className="sort-asc" children={<ICONS.ArrowUp />} />
        <span className="sort-desc" children={<ICONS.ArrowDown />} />
      </span>
    );
  };

  const _renderTitles = () => {
    const titles = columns.map((column, columnIndex) => {
      const config = Object.assign({}, DEFAULT_COLUMN, column);

      return (
        <th
          className={clsx("datatable_grid-col", config.headerClassName, {
            "sort-enabled": config.sortable,
          })}
          key={columnIndex}
        >
          <span>{config.title}</span>
          {config.sortable && _renderSortIcon(column, columnIndex)}
        </th>
      );
    });

    return (
      <tr>
        {onSelect && (
          <th className="datatable_select">
            <input
              type="checkbox"
              checked={isAllSelected}
              onChange={handleSelectAll}
            />
          </th>
        )}
        {titles}
        {allowActions && <th className="datatable_grid-col datatable_actions">Actions</th>}
      </tr>
    );
  };

  return (
    <thead
      className={clsx("datatable_grid-head", { "no-action": noAction })}
      children={_renderTitles()}
    />
  );
};

export default TableHeader;
